<template>
  <ReportWrapper
    :loading="loading"
    :on-load="loadReport"
    :tab-lv1-index="tabLv1Index"
    :tab-lv2-index="tabLv2Index"
    :showProviderFilter="isAdmin"
  >
    <ReportTable minWidth="760px">
      <thead>
        <tr>
          <th><span>Name</span></th>
          <th>
            <TableHeaderWithTooltip
              title="Clocked-in hours"
              :tooltip="tooltips['Clocked-in hours']"
            />
          </th>
          <th>
            <TableHeaderWithTooltip
              title="Productive hours"
              :tooltip="tooltips['Productive hours']"
            />
          </th>
          <th><span>Chair utilization hours</span></th>
        </tr>
      </thead>
      <tbody v-if="!loading">
        <!-- clientAdmin view -->
        <template v-if="isAdmin && dataPerProvider.length">
          <tr
            v-for="(item, index) in dataPerProvider"
            :key="index"
            :class="{
              active: item.isCurrentUserRecord,
              median: item.isMedian,
              hidden: !item.isActive || item.isHidden || item.isHiddenReport,
            }"
          >
            <td>{{ item.fullName }}</td>
            <td>{{ formatMinutes(item.clockedInMinutes) }}</td>
            <td>{{ formatMinutes(item.productiveMinutes) }}</td>
            <td>{{ formatMinutes(item.chairUtilizationMinutes) }}</td>
          </tr>

          <tr
            v-if="!userHasRecordInReport"
            class="median"
          >
            <td>Median</td>
            <td>{{ formatMinutes(median.clockedInMinutes) }}</td>
            <td>{{ formatMinutes(median.productiveMinutes) }}</td>
            <td>{{ formatMinutes(median.chairUtilizationMinutes) }}</td>
          </tr>
        </template>

        <!-- clientUser view -->
        <template v-else-if="!isAdmin && userRecord">
          <tr class="active">
            <td>{{ userRecord.fullName }}</td>
            <td>{{ formatMinutes(userRecord.clockedInMinutes) }}</td>
            <td>{{ formatMinutes(userRecord.productiveMinutes) }}</td>
            <td>{{ formatMinutes(userRecord.chairUtilizationMinutes) }}</td>
          </tr>

          <tr v-if="median">
            <td>Median</td>
            <td>{{ formatMinutes(median.clockedInMinutes) }}</td>
            <td>{{ formatMinutes(median.productiveMinutes) }}</td>
            <td>{{ formatMinutes(median.chairUtilizationMinutes) }}</td>
          </tr>

          <tr v-if="averageTop10Percent">
            <td>Average top 10 percent</td>
            <td>{{ formatMinutes(averageTop10Percent.clockedInMinutes) }}</td>
            <td>{{ formatMinutes(averageTop10Percent.productiveMinutes) }}</td>
            <td>{{ formatMinutes(averageTop10Percent.chairUtilizationMinutes) }}</td>
          </tr>
        </template>

        <NoRecordsFound
          v-else
          colspan="4"
        />
      </tbody>
    </ReportTable>

    <MetricDefinitionList
      v-if="!loading"
      :metrics="tooltips"
    />
  </ReportWrapper>
</template>

<script>
import DataService from '../../../../_services/DataService';
import MetricDefinitionList from '../../../components/Reporting/MetricDefinitionList';
import NoRecordsFound from '../../../components/Reporting/NoRecordsFound';
import ReportTable from '../../../components/Reporting/ReportTable.vue';
import ReportWrapper from '../../../components/Reporting/ReportWrapper';
import TableHeaderWithTooltip from '../../../components/Reporting/TableHeaderWithTooltip';
import Utils from '../../../utils';

export default {
  name: 'DDSChairUtilization',
  components: {
    MetricDefinitionList,
    NoRecordsFound,
    ReportTable,
    ReportWrapper,
    TableHeaderWithTooltip,
  },
  inject: ['shouldShowHiddenProviders'],
  props: ['tabLv1Index', 'tabLv2Index'],
  data() {
    return {
      dataPerProviderAll: [],
      userRole: '',
      userRecord: null,
      averageTop10Percent: null,
      median: null,
      loading: false,
      tooltips: {
        'Clocked-in hours': 'Clocked-in hours fetched from BambooHR',
        'Productive hours': 'Time scheduled for patient treatment (can generate production)',
      },
    };
  },
  computed: {
    isAdmin() {
      return this.userRole === 'clientAdmin';
    },
    userHasRecordInReport() {
      return !!this.userRecord;
    },
    showHiddenProviders() {
      return this.shouldShowHiddenProviders();
    },
    dataPerProvider() {
      return this.showHiddenProviders
        ? this.dataPerProviderAll
        : this.dataPerProviderAll.filter(this.providerIsVisible);
    },
  },
  methods: {
    async loadReport(dateRange) {
      const { start, end } = dateRange;
      this.loading = true;

      const result = await DataService.getDDSChairUtilizationReport({ start, end });

      if (result.status === 200) {
        const dataPerProvider = result.data.dataPerProvider ?? [];
        this.dataPerProviderAll = dataPerProvider;

        Utils.prependCurrentUserRecordAndMedian(dataPerProvider, result.data.median);

        this.userRecord = result.data.userRecord;
        this.averageTop10Percent = result.data.averageTop10Percent;
        this.median = result.data.median;
      } else {
        this.dataPerProviderAll = [];
      }

      this.loading = false;
    },
    formatMinutes(minutes) {
      return Utils.formatMinutes(minutes);
    },
    providerIsVisible(provider) {
      return provider.isActive && !provider.isHidden && !provider.isHiddenReport;
    },
  },
  mounted() {
    this.userRole = DataService.getRole();
  },
};
</script>
